export default "__VITE_ASSET__lORChSqe__"